(function ($) {
    'use strict';

    //Once the dailymotion library has been loaded, create a player and
    //a listener to play next video
    function dailyMotionOnPlayerReady(videoId, autoplay, published_date, videovertical) {
        var player = DM.player(document.getElementById('dmPlayer'), {
            video: videoId,
            params: {
                autoplay: autoplay
            }
        });

        player.addEventListener('end', function (e) {
            get_next_video(published_date, videovertical);
        });
    }

    //This will be called either the first time an entry is loaded or
    //in the response of ajax.
    function videoEntryAttach() {
        var $dmPlayer = $('.dmPlayer');

        if ($dmPlayer.data('provider') === 'dailymotion') {
            var videoId = $dmPlayer.data('video-id');
            var autoplay = $dmPlayer.data('autoplay');
            var published_date = $dmPlayer.data('published');
            var videovertical = $dmPlayer.data('videovertical');

            hpDailyMotion.apiReady().then(function () {
                dailyMotionOnPlayerReady(videoId, autoplay, published_date, videovertical);
            });
        }
    }

    window.hpDailyMotion = $.extend(window.hpDailyMotion || {}, {
        videoEntryAttach: videoEntryAttach
    });

    hpDailyMotion.videoEntryAttach();
})(jQuery);
